import dayjs from 'dayjs';
import { PeriodPreset, PeriodPresetEnum } from '@shared/interactions/period-picker/period-picker.interface';

export const periodPresets: PeriodPreset[] = [
    {
        label: 'Ostatnie 3 miesiące',
        name: PeriodPresetEnum.LAST_3_MONTHS,
        startAt: () => dayjs().subtract(3, 'month').startOf('day').toDate(),
        period: () => dayjs().diff(dayjs().subtract(3, 'month').startOf('day'), 'day')
    },
    {
        label: 'Ostatnie 30 dni',
        name: PeriodPresetEnum.LAST_30_DAYS,
        startAt: () => dayjs().subtract(30, 'day').startOf('day').toDate(),
        period: () => 30
    },
    {
        label: 'Ostatnie 7 dni',
        name: PeriodPresetEnum.LAST_7_DAYS,
        startAt: () => dayjs().subtract(6, 'day').startOf('day').toDate(),
        period: () => 6
    },
    {
        label: 'Ostatnie 24 godziny',
        name: PeriodPresetEnum.LAST_24_HOURS,
        startAt: () => dayjs().subtract(24, 'hour').startOf('hour').toDate(),
        period: () => 1
    },
    {
        label: 'Poprzedni tydzień',
        name: PeriodPresetEnum.PREVIOUS_WEEK,
        startAt: () => dayjs().subtract(1, 'week').startOf('week').toDate(),
        period: () => 7
    },
    {
        label: 'Poprzedni miesiąc',
        name: PeriodPresetEnum.PREVIOUS_MONTH,
        startAt: () => dayjs().subtract(1, 'month').startOf('month').toDate(),
        period: () => dayjs().subtract(1, 'month').endOf('month').diff(
            dayjs().subtract(1, 'month').startOf('month'),
            'day'
        )
    },
    {
        label: 'Bieżący miesiąc',
        name: PeriodPresetEnum.CURRENT_MONTH,
        startAt: () => dayjs().startOf('month').toDate(),
        period: () => dayjs().endOf('day').diff(dayjs().startOf('month'), 'day')
    },
    {
        label: 'Bieżący rok',
        name: PeriodPresetEnum.CURRENT_YEAR,
        startAt: () => dayjs().startOf('year').toDate(),
        period: () => dayjs().endOf('day').diff(dayjs().startOf('year'), 'day')
    },
    {
        label: 'Poprzedni rok',
        name: PeriodPresetEnum.PREVIOUS_YEAR,
        startAt: () => dayjs().subtract(1, 'year').startOf('year').toDate(),
        period: () => dayjs().subtract(1, 'year').endOf('year').diff(
            dayjs().subtract(1, 'year').startOf('year'),
            'day'
        )
    }
];
